import { jsx, jsxs } from "react/jsx-runtime";
import { SvgIcon, useTheme } from "@mui/material";
import { validateTidalLicense } from "../../base/index.js";
function GrowthGraph(props) {
  const { viewBox = "0 0 48 48", size, sx: inputSx, ...rest } = props;
  const theme = useTheme();
  const sx = typeof size === "number" ? { fontSize: size, ...inputSx } : inputSx;
  return /* @__PURE__ */ jsxs(SvgIcon, { ...rest, "data-tidal": "TidalIllustration", "data-tidal-illustration": "GrowthGraph", sx, viewBox, children: [
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M7 33h4c.2652 0 .5196.1054.7071.2929S12 33.7348 12 34v9H6v-9c0-.2652.10536-.5196.29289-.7071C6.48043 33.1054 6.73478 33 7 33Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M17 29h4c.2652 0 .5196.1054.7071.2929S22 29.7348 22 30v13h-6V30c0-.2652.1054-.5196.2929-.7071S16.7348 29 17 29Z",
        fill: theme.vars.palette.primary.light
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M27 25h4c.2652 0 .5196.1054.7071.2929S32 25.7348 32 26v17h-6V26c0-.2652.1054-.5196.2929-.7071S26.7348 25 27 25Z",
        fill: theme.vars.palette.secondary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M37.0005 20.9999h4c.2652 0 .5195.1054.7071.2929.1875.1876.2929.4419.2929.7071v21h-6v-21c0-.2652.1053-.5195.2928-.7071.1876-.1875.4419-.2929.7072-.2929Zm8.707-16.70696c-.1222-.12216-.2739-.2106-.4404-.25669-.1665-.04609-.3421-.04827-.5096-.00631l-8 2c-.2557.06597-.4748.23034-.6097.45725-.1349.22691-.1746.49795-.1104.75402.0641.25606.2269.47638.4528.61289.226.13652.4967.17815.7533.11584l4.733-1.183L31.5644 17.9999h-15.564c-.2207.0002-.4351.0733-.61.208l-12.99995 10c-.10774.0788-.19864.1783-.26733.2927-.06869.1144-.11378.2414-.13263.3735-.01884.1321-.01106.2666.0229.3957.03396.129.0934.25.17483.3557.08142.1057.18319.1941.29929.2599.1161.0658.2442.1076.37674.1231.13254.0156.26684.0044.395-.0328.12815-.0372.24756-.0997.3512-.1838l12.72995-9.792h15.66c.1376.0001.2737-.0281.3998-.083.1261-.0549.2396-.1352.3332-.236l10.353-11.14996-1.056 4.22596c-.0644.2573-.024.5296.1123.7571.1364.2275.3575.3915.6148.4559.0794.0202.161.0303.243.03.2227-.0002.439-.0748.6146-.2119.1755-.1372.3002-.329.3544-.5451l2-7.99996c.042-.1675.04-.34303-.0059-.50952-.0459-.16648-.1342-.31824-.2561-.44048Z",
        fill: theme.vars.palette.primary.dark
      }
    ),
    /* @__PURE__ */ jsx(
      "path",
      {
        d: "M45 41H3c-.55228 0-1 .4477-1 1s.44772 1 1 1h42c.5523 0 1-.4477 1-1s-.4477-1-1-1Z",
        fill: theme.vars.palette.secondary.main
      }
    )
  ] });
}
GrowthGraph.tidalIllustrationMeta = {
  categories: ["illustration"],
  name: "GrowthGraph"
};
validateTidalLicense();
export {
  GrowthGraph
};
//# sourceMappingURL=GrowthGraph.js.map
